import aiEditorPronunciationCheckFeatures from './AIEditorPronunciationCheck';
import noWatermarkFeatures from './NoWatermark';
import previewFeatures from './Preview';

const ttsFeatures = ({ packages }) => ({
  preview: {
    key: 'listen-text',
    label: 'previewTextToSpeech',
    values: previewFeatures({ packages }),
  },
  aiEditorPronunciationCheck: {
    key: 'ai-editor-pronunciation-check',
    label: 'aiEditorPronunciationCheck',
    values: aiEditorPronunciationCheckFeatures({ packages }),
  },
  noWatermark: {
    key: 'no-watermark-tts',
    label: 'noWatermarkTextToSpeech',
    values: noWatermarkFeatures({ packages }),
  },
});

export default ttsFeatures;
